export const industries = [
  { name: 'Agriculture and Agribusiness' },
  { name: 'Automotive and Transportation' },
  { name: 'Banking and Financial Services' },
  { name: 'Biotechnology and Pharmaceuticals' },
  { name: 'Construction and Real Estate' },
  { name: 'Consumer Goods' },
  { name: 'Education and Training' },
  { name: 'Energy and Utilities' },
  { name: 'Entertainment and Media' },
  { name: 'Food and Beverage' },
  { name: 'Government' },
  { name: 'Healthcare and Medical Services' },
  { name: 'Hospitality and Tourism' },
  { name: 'Information Technology (IT) and Software' },
  { name: 'Manufacturing' },
  { name: 'Mining and Natural Resources' },
  { name: 'Professional Services (Legal, Consulting, etc.)' },
  { name: 'Retail and E-commerce' },
  { name: 'Telecommunications' },
  { name: 'Transportation and Logistics' }
]
export const roles = [
  { name: 'Executive Leadership / Management' },
  { name: 'Human Resources (HR)' },
  { name:  'Finance and Accounting' },
  { name: 'Sales and Business Development' },
  { name: 'Marketing, Public Relations (PR) / Corporate Communications' },
  { name: 'Customer Service / Support' },
  { name: 'Operations' },
  { name: 'Legal and Compliance' },
  { name: 'Information Technology (IT)' },
  { name: 'Product Development / Research & Development' },
  { name: 'Procurement / Purchasing' },
  { name: 'Corporate Strategy / Business Analysis' },
  { name: 'Risk Management' },
  { name: 'Corporate Social Responsibility (CSR) / Sustainability' },
  { name: 'Facilities Management' },
  { name: 'Business Intelligence / Data Analytics' },
  { name: 'Cross functional' }
]

export const levels = [
  {
    name: 'Functional',
    description: 'A team within a function (e.g. finance, HR, IT).'
  },
  {
    name: 'Project',
    description: 'A team that has been put together for a short time to lead a specific project.'
  },
  {
    name: 'Front-line Leadership',
    description: 'A team of front-line leaders, team leaders, or junior leaders.'
  },
  {
    name: 'Functional Leadership',
    description: 'A team responsible for leading an organisational function (e.g. finance, HR, IT).'
  },
  {
    name: 'Business Leadership',
    description: 'A team responsible for leading a business within a wider organisation (e.g. retail leadership team or wholesale leadership team).'
  },
  {
    name: 'Enterprise Leadership',
    description: 'The most senior executive team in an organisation or enterprise.'
  },
  {
    name: 'Board',
    description: 'A team that is responsible to external shareholders or stakeholders for company governance and strategy.'
  }
]

export const expertise = ['Novice', 'Beginner', 'Competent', 'Proficient', 'Expert', 'Master']

export const valueColors = ['var(--red)', 'var(--yellow)', 'var(--babypink)', 'white', 'var(--skyblue)', 'var(--blue)']
export const valueTextColors = ['white', 'black', 'black', 'black', 'black', 'white']

const indexValues = [0.5, 1.5, 2.5, 3.5, 4.5, 5]
export const indexFromValue = value => indexValues.findIndex(x => value <= x)
export const colorFromValue = value => valueColors[indexFromValue(value)]